import Card from "./card.js";
export default class ClassicCard extends Card {
  constructor(s, t, i, h, r, c, e, a, o, d, l, n, u, p, f, m) {
    super(s, t, i, h, r, c, e, a, o, d, l, n, u, p, f, m),
      (this.U = "ab-classic-card"),
      (this.V = !0);
  }
  ss() {
    const s = {};
    return (
      (s[Card.hs.ts] = Card.es.St),
      (s[Card.hs.ns] = this.id),
      (s[Card.hs.ls] = this.viewed),
      (s[Card.hs.st] = this.title),
      (s[Card.hs.os] = this.imageUrl),
      (s[Card.hs.it] = this.description),
      (s[Card.hs.us] = this.updated),
      (s[Card.hs.cs] = this.created),
      (s[Card.hs.bs] = this.categories),
      (s[Card.hs.ds] = this.expiresAt),
      (s[Card.hs.URL] = this.url),
      (s[Card.hs.ps] = this.linkText),
      (s[Card.hs.fs] = this.aspectRatio),
      (s[Card.hs.xs] = this.extras),
      (s[Card.hs.gs] = this.pinned),
      (s[Card.hs.js] = this.dismissible),
      (s[Card.hs.ys] = this.clicked),
      (s[Card.hs.zs] = this.test),
      s
    );
  }
}
